import { createFileRoute, useSearch } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { CaptionResultsCanvas } from '@/features/app-shell/canvases/caption-results-canvas'

export const Route = createFileRoute('/app/caption-results')({
  validateSearch: (search: Record<string, unknown>) => ({ taskId: typeof search.taskId === 'string' ? search.taskId : '' }),
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: CaptionResultsRoute,
})

function CaptionResultsRoute() {
  const { taskId } = useSearch({ from: '/app/caption-results' })
  return <CaptionResultsCanvas taskId={taskId} />
}
